import duckNotFound404Img from "../../../assets/images/duckNotFound404.svg";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found-container">
      <img src={duckNotFound404Img} alt="Ilustração" />
      <h1>Página não encontrada</h1>
      <p>
        A página que você procura não foi encontrada, ou algum outro erro <br />
        aconteceu. Volte para a <a href="/">tela inicial</a>, ou entre em contato com o administrador.
      </p>
    </div>
  );
};

export default NotFound;
